import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';

import CustomButton from '../../../../../../../../../../../../../../../lib/designSystem/Button';

interface CessionStatusDialogProps {
  open: boolean;
  onClose: () => void;
  documentStatus: {
    folio: string;
    status: 'accepted' | 'rejected' | 'pending' | 'invalid';
    message: string;
    subType: string;
    businessIdentifier: string;
  } | null;
}

const CessionStatusDialog: React.FC<CessionStatusDialogProps> = ({
  open,
  onClose,
  documentStatus,
}) => {
  if (!documentStatus) return null;
  const statusText = () => {
    switch (documentStatus?.status) {
      case 'accepted':
        return { text: 'Aceptada', color: '#2e7d32' };
      case 'rejected':
        return { text: 'Rechazada', color: '#c62828' };
      case 'pending':
        return { text: 'Pendiente', color: '#e8f5e9' };
      case 'invalid':
        return { text: 'Inválida', color: '#2e7d32' };
      default:
        return { text: 'Pendiente', color: '#e8f5e9' };
    }
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <DialogTitle id="form-dialog-title">Estado de la Cesión</DialogTitle>
      <DialogContent style={{ minHeight: 100, padding: 24 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {/* Detalles de la factura */}
          <div
            style={{
              padding: '16px',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
            }}
          >
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Detalles de la Factura
            </Typography>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '8px',
              }}
            >
              <Typography variant="body2" color="textSecondary">
                Folio:
              </Typography>
              <Typography variant="body2" style={{ textAlign: 'right' }}>
                {documentStatus?.folio}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                RUT Empresa:
              </Typography>
              <Typography variant="body2" style={{ textAlign: 'right' }}>
                {documentStatus?.businessIdentifier}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Tipo:
              </Typography>
              <Typography variant="body2" style={{ textAlign: 'right' }}>
                {documentStatus?.subType}
              </Typography>
            </div>
          </div>

          {/* Estado de la cesión */}
          <div
            style={{
              padding: '16px',
              backgroundColor: documentStatus?.status ? '#e8f5e9' : '#ffebee',
              borderRadius: '8px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}
          >
            <Typography
              variant="subtitle2"
              style={{
                color: statusText().color,
              }}
            >
              Estado: {statusText().text}
            </Typography>
            <Typography variant="body2" style={{ color: 'rgba(0, 0, 0, 0.7)' }}>
              {documentStatus?.message}
            </Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary">
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default CessionStatusDialog;
